import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Navigate, Outlet, useParams } from 'react-router'

import { ConnectionIcon } from 'app/common/presentation'
import { useConnections } from 'app/connections/application'
import { AvailableOrInstalledConnection, isInstalledConnection } from 'app/connections/types'

import { ConnectionProvider } from '../components/ConnectionContext'
import { mapToConnectionName, mapToUrl } from '../connectionUrlMapper'
import { isConfigured } from '../settings/isConfigured'
import styles from './Connect.module.scss'

type ConnectConnectionParams = {
  name: string
}

const ConnectConnection = () => {
  const { name } = useParams<ConnectConnectionParams>() as ConnectConnectionParams
  const { t } = useTranslation('connections')

  const { getConnection: getConnection } = useConnections()

  const [connection, setConnection] = useState<AvailableOrInstalledConnection>()

  useEffect(() => {
    setConnection(getConnection(mapToConnectionName(name)) ?? undefined)
  }, [getConnection, name])

  if (connection && isInstalledConnection(connection) && isConfigured(connection)) {
    return <Navigate to={`/connections/${mapToUrl(connection.name)}/manage/settings`} replace />
  }

  return connection ? (
    <div className={styles.setup}>
      <header className={styles.pageHeader}>
        <div className={styles.connectionIcon}>
          <ConnectionIcon connection={connection} />
        </div>
        <div>
          <h1>{`${t('setup.connect')} ${t(`available.${connection.name}.displayName`)}`}</h1>
          <p>{t(`setup.${connection.name}.description`)}</p>
        </div>
      </header>
      <ConnectionProvider connection={connection}>
        <Outlet />
      </ConnectionProvider>
    </div>
  ) : (
    <div>{`Connection ${name} not found`}</div>
  )
}

export default ConnectConnection
